import React from "react";
import update from "immutability-helper";

import {browserHistory} from "react-router";
import {modal} from "../../core/utilities/modal";
import {signupHelper} from "../../helpers/Signup/";
import {phoneNumberFormatter} from "../../helpers/General/PhoneNunberFormatter";

export default class SignupCard extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            userData: {
                firstname: "",
                lastname: "",
                company: "",
                phone: "",
                email: "",
                password: "",
                confirmPassword: "",
            },
            accountType: "tenant",
            userConfirmed: false,
            mustSetPassword: false,
            userType: null,
        };

        signupHelper.setReferralLink(this.props.params.referral);
    }

    componentDidMount() {
        var self = this;
        if (this.props.params.token) {
            signupHelper.confirmUser(this.props.params.token, function (data) {
                if (data.status != 409) {
                    let mustSetPassword = false;
                    if (
                        data.data.user_type == "contractor" ||
                        data.data.user_type == "property-manager" ||
                        data.data.user_type == "tenant" ||
                        data.data.user_type == "owner"
                    ) {
                        self.props.onChange("password");
                        modal.showInfo("Thank you for confirming your email, now set your password.", "success", "top", "center");
                        mustSetPassword = true;
                    } else {
                        self.props.onChange("thankyou");
                        modal.showInfo("Thank you for confirming your email!  You're all set.", "success", "top", "center");
                    }
                    self.setState({
                        userConfirmed: true,
                        mustSetPassword: mustSetPassword,
                        userData: update(self.state.userData, {
                            username: {$set: data.data.username},
                        }),
                    });
                }
            });
        }
    }

    componentWillUpdate(nextProps, nextState) {
    }

    signUp(e) {
        e.preventDefault();

        const userData = this.state.userData;

        if (userData.firstname == "") {
            jQuery(".login-box-msg").html("Enter a firstname!");
            return;
        }

        if (userData.lastname == "") {
            jQuery(".login-box-msg").html("Enter a lastname!");
            return;
        }

        if (userData.company == "") {
            jQuery(".login-box-msg").html("Enter a company name!");
            return;
        }

        if (userData.phone == "") {
            jQuery(".login-box-msg").html("Enter a phone number!");
            return;
        }

        if (userData.email == "") {
            jQuery(".login-box-msg").html("Enter an email address!");
            return;
        }

        if (!this.emailIsValid(userData.email)) {
            jQuery(".login-box-msg").html("Enter a valid email address!");
            return;
        }

        if (userData.password == "" || userData.confirmPassword == "") {
            jQuery(".login-box-msg").html("Enter a password!");
            return;
        }

        if (userData.password != userData.confirmPassword) {
            jQuery(".login-box-msg").html("Passwords do not match!");
            return;
        }

        if (!jQuery("#terms-of-service").is(":checked")) {
            jQuery(".login-box-msg").html("You must agree to our terms of use!");
            return;
        }

        signupHelper.createUser(this.state.userData, function (data) {
            if (data.status == 409) {
                modal.showInfo(
                    "Please use another email to sign up.",
                    "warning",
                    "top",
                    "center"
                );
                jQuery(".login-box-msg").html("This email cannot be used!");
            } else {
                jQuery(".login-box-msg").html("");
                jQuery(".login").fadeOut();
                jQuery(".back").fadeIn();
                browserHistory.replace("/");
            }
        });
    }

    createPassword(e) {
        var self = this;
        const userData = this.state.userData;

        if (userData.password == "" || userData.confirmPassword == "") {
            jQuery(".login-box-msg").html("Enter a password!");
            return;
        }

        if (userData.password != userData.confirmPassword) {
            jQuery(".login-box-msg").html("Passwords do not match!");
            return;
        }

        if (!jQuery("#terms-of-service").is(":checked")) {
            jQuery(".login-box-msg").html("You must agree to our terms of use!");
            return;
        }

        signupHelper.createPasswordWithoutValidation(
            this.state.userData,
            function (data) {
                jQuery(".login-box-msg").html("");
                if (data.status != 409) {
                    self.setState({
                        userConfirmed: true,
                        mustSetPassword: false,
                    });
                }
            }
        );
    }

    login(e) {
        e.preventDefault();
        browserHistory.replace("/login");
    }

    reset(e) {
        e.preventDefault();
        this.setState({
            userData: null,
        });
    }

    emailIsValid(email) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    emailChange(e) {
        this.setState({
            userData: update(this.state.userData, {
                email: {$set: e.target.value},
            }),
        });
    }

    phoneNumberChange(e) {
        var phoneNumber = phoneNumberFormatter.format(e.target.value);

        this.setState({
            userData: update(this.state.userData, {
                phone: {$set: phoneNumber},
            }),
        });
    }

    firstnameChange(e) {
        this.setState({
            userData: update(this.state.userData, {
                firstname: {$set: e.target.value},
            }),
        });
    }

    lastnameChange(e) {
        this.setState({
            userData: update(this.state.userData, {
                lastname: {$set: e.target.value},
            }),
        });
    }

    companyChange(e) {
        this.setState({
            userData: update(this.state.userData, {
                company: {$set: e.target.value},
            }),
        });
    }

    passwordChange(e) {
        this.setState({
            userData: update(this.state.userData, {
                password: {$set: e.target.value},
            }),
        });
    }

    confirmpasswordChange(e) {
        this.setState({
            userData: update(this.state.userData, {
                confirmPassword: {$set: e.target.value},
            }),
        });
    }

    handleUserTypeChanged(e) {
        const userType = e.target.value;
        this.setState({
            userType: userType,
        });
        this.props.onChange(userType);
    }

    render() {
        const userData = this.state.userData;
        const userConfirmed = this.state.userConfirmed;
        const mustSetPassword = this.state.mustSetPassword;
        const userType = this.props.value;
        var chosenAccount = (!(this.state.userType == null || this.state.userType === "default") || mustSetPassword || userConfirmed);

        return (
            <div class="new-login-card">
                <div class="">
                    <h4 class="title login-right-panel-text">Let's get you started!</h4>
                </div>
                <p className="category">
                    {
                        !chosenAccount &&
                        ("Choose the best option that describes who you are")
                    }
                </p>
                <div class="login-box-body">
                    <p class="login-box-msg">
                        <span></span>
                    </p>
                    {!userConfirmed && !mustSetPassword && (
                        <select className="form-control form-group has-feedback" onChange={this.handleUserTypeChanged.bind(this)}>
                            <option value="default">Select an option</option>
                            <option value="PM">I am a Property Manager.</option>
                            <option value="tenant">I am a Tenant.</option>
                            <option value="owner">I am an Owner.</option>
                            <option value="contractor">I am a Contractor.</option>
                        </select>
                    )}
                    {mustSetPassword && (
                        <div>
                            <div class="form-group has-feedback">
                                <input
                                    type="password"
                                    class="form-control"
                                    id="password"
                                    value={userData.password}
                                    onChange={this.passwordChange.bind(this)}
                                    placeholder="Password"
                                    style={{backgroundColor: "white", paddingLeft: "50px"}}/>
                                <i class="form-control-feedback fa fa-lock"></i>
                            </div>
                            <div class="form-group has-feedback">
                                <input
                                    type="password"
                                    class="form-control"
                                    id="repassword"
                                    value={userData.confirmPassword}
                                    onChange={this.confirmpasswordChange.bind(this)}
                                    placeholder="Re-Enter Password"
                                    style={{backgroundColor: "white", paddingLeft: "50px"}}/>
                                <i class="form-control-feedback fa fa-lock"></i>
                            </div>
                            <div class="form-group has-feedback no-margin-bottom">
                                <p>
                                    <input type="checkbox" name="terms-of-service" id="terms-of-service"/>
                                    {" "} I have read and agree to the{" "}
                                    <a target="_blank" href="https://particlespace.com/terms-of-service/">
                                        terms of use
                                    </a>
                                    .
                                </p>
                            </div>
                            <div className="row login-inputs">
                                <div>
                                    <div className="loading"><i className="fa fa-cog fa-spin"></i></div>
                                    <button type="submit" onClick={this.createPassword.bind(this)} name="submit" id="login" className="btn btn-secondary btn-info btn-fill btn-block btn-flat login" style={{marginBottom: "15px"}}>
                                        Create Password
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                    {userConfirmed && !mustSetPassword && (
                        <div>
                            <div class="form-group has-feedback">
                                <span class="confirmed">
                                  <i class="fa fa-check-circle" aria-hidden="true"></i>
                                </span>
                                <p> Your acount is now confirmed! Click the button below to head back to login. We are
                                    so happy to have you! </p>
                            </div>
                            <div className="row login-inputs">
                                <div>
                                    <div className="loading"><i className="fa fa-cog fa-spin"></i></div>
                                    <button type="submit" onClick={this.login.bind(this)} name="submit" id="login" class="btn btn-secondary btn-info btn-fill btn-block btn-flat" style={{marginBottom: "15px"}}>
                                        Login
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                    {!userConfirmed && !mustSetPassword && (
                        <form action="" method="post" onsubmit="return false;">
                            {userType != null && userType === "PM" ? (
                                <div>
                                    <div class="form-group has-feedback">
                                        <input
                                            type="text"
                                            class="form-control"
                                            id="firstname"
                                            value={userData.firstname}
                                            onChange={this.firstnameChange.bind(this)}
                                            placeholder="Firstname"
                                            style={{backgroundColor: "white", paddingLeft: "50px"}}/>
                                        <i class="form-control-feedback fa fa-user"></i>
                                    </div>
                                    <div class="form-group has-feedback">
                                        <input
                                            type="text"
                                            class="form-control"
                                            id="lastname"
                                            value={userData.lastname}
                                            onChange={this.lastnameChange.bind(this)}
                                            placeholder="Lastname"
                                            style={{backgroundColor: "white", paddingLeft: "50px"}}/>
                                        <i class="form-control-feedback fa fa-user"></i>
                                    </div>
                                    <div class="form-group has-feedback">
                                        <input
                                            type="text"
                                            class="form-control"
                                            id="company"
                                            value={userData.company}
                                            onChange={this.companyChange.bind(this)}
                                            placeholder="Company Name"
                                            style={{backgroundColor: "white", paddingLeft: "50px"}}/>
                                        <i class="form-control-feedback fa fa-building"></i>
                                    </div>
                                    <div class="form-group has-feedback">
                                        <input
                                            type="text"
                                            class="form-control"
                                            id="phone"
                                            value={userData.phone}
                                            onChange={this.phoneNumberChange.bind(this)}
                                            placeholder="Phone"
                                            style={{backgroundColor: "white", paddingLeft: "50px"}}/>
                                        <i class="form-control-feedback fa fa-phone"></i>
                                    </div>
                                    <div class="form-group has-feedback">
                                        <input
                                            type="text"
                                            name="log"
                                            class="form-control"
                                            id="email"
                                            value={userData.email}
                                            onChange={this.emailChange.bind(this)}
                                            placeholder="Email"
                                            style={{backgroundColor: "white", paddingLeft: "50px"}}/>
                                        <i class="form-control-feedback fa fa-envelope"></i>
                                    </div>
                                    <div class="form-group has-feedback">
                                        <input
                                            type="password"
                                            class="form-control"
                                            id="password"
                                            value={userData.password}
                                            onChange={this.passwordChange.bind(this)}
                                            placeholder="Password"
                                            style={{backgroundColor: "white", paddingLeft: "50px"}}/>
                                        <i class="form-control-feedback fa fa-lock"></i>
                                    </div>
                                    <div class="form-group has-feedback">
                                        <input
                                            type="password"
                                            class="form-control"
                                            id="repassword"
                                            value={userData.confirmPassword}
                                            onChange={this.confirmpasswordChange.bind(this)}
                                            placeholder="Re-Enter Password"
                                            style={{backgroundColor: "white", paddingLeft: "50px"}}/>
                                        <i class="form-control-feedback fa fa-lock"></i>
                                    </div>
                                    <div class="form-group has-feedback">
                                        <p>
                                            <input type="checkbox" name="terms-of-service" id="terms-of-service"/>
                                            {" "} I have read and agree to the{" "}
                                            <a target="_blank" href="https://particlespace.com/terms-of-service/">
                                                terms of use
                                            </a>
                                            .
                                        </p>
                                    </div>
                                    <div className="row login-inputs">
                                        <div>
                                            <div className="loading"><i className="fa fa-cog fa-spin"></i></div>
                                            <button type="submit" onClick={this.login.bind(this)} name="submit" id="login" className="btn btn-info btn-fill btn-block btn-flat back">
                                                Go Back
                                            </button>
                                            <button type="submit" onClick={this.signUp.bind(this)} name="submit" id="login" className="btn btn-info btn-login-fill btn-block btn-flat login" style={{marginBottom: "15px"}}>
                                                <img height="1" width="1" style={{display: "none"}} alt="" src="https://px.ads.linkedin.com/collect/?pid=2004218&conversionId=2171594&fmt=gif"/>
                                                Sign Up
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                userType != null &&
                                userType != "default" && (
                                    <div class="row">
                                        <div class="col-md-12">
                                            Your property manager will invite you to join Particle
                                            Space, and you will receive an email from us with an
                                            activation link!
                                        </div>
                                        <div class="row adjust">
                                            <div class="col-md-12"></div>
                                        </div>
                                    </div>
                                )
                            )}
                            <div className="row text-center no-margin" style={{padding: "10px", paddingBottom: "0px"}}>
                                <p>
                                    Already have an account?{" "}
                                    <a onClick={this.login} className="register"> Login </a>
                                </p>
                            </div>
                        </form>
                    )}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// app/components/Signup/SignupCard.jsx